(function () {
  var MIN_FONT_SIZE = 16;
  var MAX_LINES = 2;

  function fits(el, maxHeight) {
    return el.scrollWidth <= el.clientWidth + 1 && el.scrollHeight <= maxHeight;
  }

  function fitValue(el) {
    el.style.fontSize = '';
    var style = window.getComputedStyle(el);
    var size = parseFloat(style.fontSize);
    var lineHeight = parseFloat(style.lineHeight) || size;
    var maxHeight = lineHeight * MAX_LINES + 1;

    while (size > MIN_FONT_SIZE && !fits(el, maxHeight)) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
  }

  function fitSection(section) {
    section.querySelectorAll('.product-stats__value').forEach(fitValue);
  }

  function fitAll() {
    document.querySelectorAll('.product-stats').forEach(fitSection);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.product-stats');
    if (section) fitSection(section);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAll);
  }

  fitAll();
})();
